// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1836":"ce1a019c","6380":"86f38aeb","8285":"24737fe2"}[chunkId] || chunkId) + "." + {"521":"b91e219ff120ed35","1352":"f4004bd46c990bf1","1836":"bb5aa238fc1da0d5","6380":"bf868e3191011833","8285":"5748aca49083abe1","8964":"ea140a1738152a2f"}[chunkId] + ".js";
};